import { Message } from '@/features/tools/types'
import {
  type ParsedDeliverable,
  parseDeliverablesFromText,
} from '@/utils/deliverableParser'

export const makeEmptyThread = () => {
  return {
    messages: [],
    tool: '',
    userId: '',
    organizationId: '',
    createdAt: new Date().toISOString(),
    projectId: '',
  }
}

/**
 * Extracts all artifacts from a thread's messages
 * @param messages - Array of messages from the thread
 * @returns Array of all parsed deliverables found in the messages
 */
export function extractAllArtifactsFromThread(
  messages: Message[],
): ParsedDeliverable[] {
  const artifacts: ParsedDeliverable[] = []

  messages.forEach((message) => {
    if (message.role !== 'assistant') return

    message.content.forEach((contentItem) => {
      if (contentItem.type === 'text' && contentItem.text) {
        const parsed = parseDeliverablesFromText(contentItem.text)
        artifacts.push(...parsed.deliverables)
        if (parsed.incompleteDeliverable) {
          artifacts.push(parsed.incompleteDeliverable)
        }
      }
    })
  })

  return artifacts
}
